<template>
  <div class="time-select-content" :class="{ 'time-select-content-swi': switchIcon }">
    <img :src="require('@/assets/images/service/customerscoring/analysis-date-select-icon.png')" class="icon" alt="" />
    <div class="time-view" :class="{ 'switch-icon-view': switchIcon }">
      <div @click="changeTimePickerVisible('sStartTime')" class="time-value">{{ sStartTime }}</div>
      <div class="zhi">至</div>
      <div @click="changeTimePickerVisible('sEndTime')" class="time-value">{{ sEndTime }}</div>
    </div>
    <img
      v-if="switchIcon"
      @click="openOrder"
      :src="require('@/assets/images/service/customerscoring/analysis-date-switch-icon.png')"
      class="icon"
      alt=""
    />
    <!-- 顺序切换弹窗 -->
    <div class="order" v-show="isShowOrder">
      <div class="order-item" v-for="item in objOrder" :key="item.id" @click="selectOrderText(item.id)">{{ item.name }}</div>
    </div>
    <!--    时间选择弹窗    -->
    <VantPopup v-model="bTimeVisible" position="bottom" round >
      <DatetimePicker :value="timeSelect" @confirm="setTimeValue" @cancel="changeTimePickerVisible" type="date"  :max-date="maxDate"   :min-date="dateStartTime"></DatetimePicker>
    </VantPopup>
  </div>
</template>

<script>
import { DatetimePicker, Popup } from "vant";
import day from "dayjs";
import { Toast } from "mint-ui";
import {getTimeDate} from "@/js/service"
export default {
  name: "timeselect",
  props: {
    // 是否显示后置切换图标
    switchIcon: Boolean,
  },
  components: {
    DatetimePicker,
    VantPopup: Popup,
  },
  data() {
    return {
      maxDate:new Date(),
      // 开始时间
      sStartTime: "开始时间",
      // 结束时间
      sEndTime: "结束时间",
      // 选择器显示
      bTimeVisible: false,
      // 选择器的绑定值
      sTimeSelect: "sStartTime",
      // 顺序切换
      isShowOrder: false,
      // 排序方式
      nOrderId: null,
      // 顺序切换按钮文字
      objOrder: [
        { id: 2, name: "项目服务评分降序" },
        // { id: 3, name: "用户满意评分降序" },
        // { id: 5, name: "综合服务评分降序" },
        { id: 1, name: "项目服务评分升序" },
        // { id: 4, name: "用户满意评分升序" },
        // { id: 6, name: "综合服务评分升序" },
      ],
      dateStartTime:new Date(2022,0,14)//有数据的最开始时间
    };
  },
  created(){
    this.getTime()
  },

  computed: {
    // 选择器绑定值
    timeSelect: {
      get() {
        return this[this.sTimeSelect];
      },
    },
  },
  methods: {
    // 获取有数据的时间
    getTime(){
      getTimeDate({code:'index'}).then(res=>{
        if(res.data.data.result.start_time){
              this.dateStartTime=new Date(res.data.data.result.start_time)
        }
      })
    },
    //   回复数据
    newTem() {
      Object.assign(this.$data, this.$options.data()); // 初始化data
    },
    selectOrderText(id) {
      // 选择排序方式
      this.nOrderId = id;
      this.$emit("screen", { sStartTime: this.sStartTime, sEndTime: this.sEndTime, nOrderId: this.nOrderId });
      this.isShowOrder = false;
    },
    // 打开顺序弹框
    openOrder() {
      this.isShowOrder = !this.isShowOrder;
    },
    /**
     * 改变弹窗显示和设置时间绑定值
     * @param key
     */
    changeTimePickerVisible(keyName) {
      this.sTimeSelect = keyName;
      this.bTimeVisible = !this.bTimeVisible;
      this.isShowOrder = false;
    },
    // 判断两个时间的前后
		compareDate(currentTime, activeTime) {
			let currentTimes = currentTime.replace(/-/g, '/');
			let activeTimes = activeTime.replace(/-/g, '/');
			let a = (Date.parse(activeTimes) - Date.parse(currentTimes)) / 3600 / 1000;
			if (a < 0) {
				return false;
			} else if (a > 0) {
				return true;
			}
		},
    /**
     * 设置当前时间
     * @param v
     */
    setTimeValue(v) {
      this[this.sTimeSelect] = new day(v).format("YYYY-MM-DD");
           if(this.sStartTime!="开始时间" && this.sEndTime!="结束时间"){
        if( this.compareDate(this.sEndTime,this.sStartTime)){
          console.log(1)
              Toast({
                            message: "开始时间不能晚于结束时间",
                            duration: 2000
                        });
        }
      }
      this.$emit("screen", { sStartTime: this.sStartTime, sEndTime: this.sEndTime, nOrderId: this.nOrderId });
      this.bTimeVisible = !this.bTimeVisible;
    },
  },
};
</script>

<style scoped lang="scss">
.time-select-content {
  height: 80px;
  background: #f7f7f7;
  border-radius: $commonRadius;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  position: relative;
  .order {
    // width: 240px;
    // height: 488px;
    white-space: nowrap;
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 7px;
    position: absolute;
    right: 22px;
    top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    padding: 0 20px;
    .order-item {
            white-space: nowrap;
      height: 81px;
      line-height: 81px;
      border-bottom: 1px solid #f5f5f5;
    }
  }

  .icon {
    width: 40px;
    height: 40px;
  }

  .time-view {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 94px 0 56px;
    color: #a2a2a2;
    font-size: $smallSize;
    .time-value{
      width:40%;
      text-align: center;
    }

    .zhi {
      font-size: $baseSize;
      color: #858585;
    }
  }

  .switch-icon-view {
    padding: 0 80px;
  }
}

.time-select-content-swi {
  padding: 0 16px;
}
</style>
